module.exports = {
  debugInfoEnabled: false,
  baseUrl: 'https://naersadmin.nasc.cc'
};



// WEBPACK FOOTER //
// ./config/env/production.js